import {useState, useEffect} from 'react';
import {compose} from '../../lib/compose';
import {useForm} from 'react-hook-form';
import withAlerts from '../../lib/withAlerts';
import Accordion from 'react-bootstrap/Accordion';
import {Modal,Row, Col, Form, Button} from 'react-bootstrap';
import {useTicketMutations} from '../support/ticketMutations';
import cx from 'classnames';
import {ErrorMessage} from "@hookform/error-message";

export const SupportTab = ({modaltrigger = false, change = () => {}, alerts = () => {}}) => {
  const { register, handleSubmit, reset, watch, formState:{errors} } = useForm({
    mode: 'onBlur',
    criteriaMode: 'all'
  });
  const {success, error} = alerts;
  const [showCreateTicket, setShowCreateTicket] = useState(false);
  
  useEffect(() => {
    modaltrigger && handleShowCreateTicket();
  },[modaltrigger]);

  const handleShowCreateTicket = () => {
    reset();
    setShowCreateTicket(true);
  }
  const handleClose = () => {
    change(false);
    setShowCreateTicket(false);    
  };
  const {createAzureTicket} = useTicketMutations();

  const ticketIssueType = watch('ticketIssueType');
  const handleTicket = async (formData) => {
    
    const createTicket = await createAzureTicket({variables: {
      workItem: {
        work_item_fields: [
          {
            "op": "add",
            "path": "/fields/System.Title",
            "from": null,
            "value": formData?.ticketSubject
          },
          {
            "op": "add",
            "path": "/fields/System.Description",
            "from": null,
            "value": `IssueType: ${formData?.ticketIssueType}<br>Description: ${formData?.ticketDescription}<br>Name: ${formData?.ticketName}<br>Email: ${formData?.ticketEmail}`
          }                    
        ]
      }
    }});

    if(createTicket?.errors) {
        error({msg:'There was an error submitting your ticket. Please try again.'});
    } else {
        success({msg:`We've received your message and will email you shortly.`});
        reset();
        handleClose();
    }
      
  }
  
  const files = {
    portal: `/user_agreement/support/Privoro-Fulcrum-Cloud2-Portal-Manual.pdf`,
    cloud: `/user_agreement/support/cloud_release_notes.pdf`,
    ios: `user_agreement/support/ios_release_notes.pdf`,
    firmware: `/user_agreement/support/firmware_release_notes.pdf`,
    android: `/user_agreement/support/android_release_notes.pdf`
  };

  return (
    <>  
      <div className="support-tabs">
          <Row>
              <Col sm="6" className="pb-3">
                  <div className="section-header">Frequently Asked Questions</div>
              </Col>
              <Col sm="6" className="section-right pt-3 pb-3">
                <div className="section-header">Recent Updates</div>
              </Col>
          </Row>
          <Row>
              <Col sm="6">
                  <Accordion flush defaultActiveKey="0" alwaysOpen>
                      <Accordion.Item eventKey="0">
                          <Accordion.Header>
                              Getting Started
                          </Accordion.Header>
                          <Accordion.Body>
                              <a href={files.portal} target="_blank">Privoro Portal Administrator Guide</a>
                          </Accordion.Body>
                      </Accordion.Item>
                  </Accordion>
              </Col>
              <Col sm="6" className="section-right pb-3">
                  <Accordion flush defaultActiveKey="0" alwaysOpen>
                      <Accordion.Item eventKey="0">
                          <Accordion.Header>Privoro Fulcrum Cloud Release</Accordion.Header>
                          <Accordion.Body>
                              <a href={files.cloud} target="_blank">Cloud Release Notes</a>
                          </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="1">
                          <Accordion.Header>
                              Privoro iOS App Release
                          </Accordion.Header>
                          <Accordion.Body>
                              <a href={files.ios} target="_blank">iOS App Release Notes</a>
                          </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="2">
                          <Accordion.Header>
                              Privoro Android App Release
                          </Accordion.Header>
                          <Accordion.Body>
                              <a href={files.android} target="_blank">Android App Release Notes</a>
                          </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="3">
                          <Accordion.Header>
                              SafeCase Firmware Release
                          </Accordion.Header>
                          <Accordion.Body>
                              <a href={files.firmware} target="_blank">Firmware Release Notes</a>
                          </Accordion.Body>
                      </Accordion.Item>
                  </Accordion>
              </Col>
          </Row>
      </div>
      <Modal
        data-testid="create-ticket-popup"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showCreateTicket}
        onHide={handleClose}
        className="modal-white"
        animation={false}
        backdrop="static"
        >
        <Form onSubmit={handleSubmit(handleTicket)}>
          <Modal.Header
            closeButton
            closeVariant="white"
          >
          <h4>Create a Ticket</h4>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col>
              <Form.Group className="mb-3">
                <Form.Control
                  {...register('ticketName', {
                    required: "Ticket Name is required",
                    maxLength: {
                      value: 50,
                      message: "Length of Name exceeds 50 characters"
                    }
                  })}
                  placeholder="Name" 
                  className={cx({'error-input': errors.ticketName})}
                  type="text"
                />
              </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
              <Form.Group className="mb-3">
                <Form.Control
                  {...register('ticketEmail', {
                    required: "Email address is required",
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: 'Invalid Email'
                    }
                  })}
                  placeholder="Email" 
                  className={cx({'error-input': errors.ticketEmail})}
                  type="email"
                />
              </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
              <Form.Group className="mb-3">
                <Form.Control
                  {...register('ticketSubject', {
                    required: "Subject is required",
                    maxLength: {
                      value: 50,
                      message: "Length of Subject exceeds 50 characters"
                    }
                  })}
                  placeholder="Subject" 
                  className={cx({'error-input': errors.ticketSubject})}
                  type="text"
                />
              </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Select
                    {...register('ticketIssueType', {
                      required: "Ticket Issue Type is required"
                    })}
                    placeholder="Issue Type"
                    className={cx({'error-input': errors.ticketIssueType}, {'select-gray-opton': ticketIssueType === '', 'select-black-opton': ticketIssueType !== ''})}>
                      <option value="" default hidden>Issue Type</option>
                      <option value="SafeCase">SafeCase</option>
                      <option value="Mobile App">Mobile App</option>
                      <option value="Portal">Portal</option>
                      <option value="Other">Other - Billing, Licensing, Login etc.</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
              <Form.Group>
                <Form.Control
                  {...register('ticketDescription', {
                    required: "Description is required"
                  })}
                  placeholder="Description"
                  as="textarea"
                  rows="5"
                  className={cx({'error-input': errors.ticketDescription})}
                  />
              </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col className="mt-3">
                <div className="privoro-black">
                  <ErrorMessage
                    errors={errors}
                    name="ticketEmail"
                    render={({ messages }) =>
                      messages &&
                      Object.entries(messages).map(([type, message]) => (
                         <strong key={type}>{message}<br/></strong>
                      ))
                    }
                  />
                  <ErrorMessage
                    errors={errors}
                    name="ticketName"
                    render={({ messages }) =>
                      messages &&
                      Object.entries(messages).map(([type, message]) => (
                         <strong key={type}>{message}<br/></strong>
                      ))
                    }
                  />
                  <ErrorMessage
                    errors={errors}
                    name="ticketSubject"
                    render={({ messages }) =>
                      messages &&
                      Object.entries(messages).map(([type, message]) => (
                        <strong key={type}>{message}<br/></strong>
                      ))
                    }
                  />
                  <ErrorMessage
                    errors={errors}
                    name="ticketIssueType"
                    render={({ messages }) =>
                      messages &&
                      Object.entries(messages).map(([type, message]) => (
                         <strong key={type}>{message}<br/></strong>
                      ))
                    }
                  />
                  <ErrorMessage
                    errors={errors}
                    name="ticketDescription"
                    render={({ messages }) =>
                      messages &&
                      Object.entries(messages).map(([type, message]) => (
                        <strong key={type}>{message}<br/></strong>
                      ))
                    }
                  />
                </div>
              </Col>
            </Row>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-end mt-3">
            <Button onClick={() => handleClose()} className="btn btn-secondary">Cancel</Button>
            <Button data-testid="popup-submit-button" type="submit" className="ms-3 btn btn-primary">Submit</Button>
          </div>
        </Modal.Footer>
        </Form>
      </Modal>
    </> 
  );
}

export default compose(withAlerts)(SupportTab);
